export enum GeoTourTag {
    europe = "europe",
    copenhagen = "copenhagen",
    zealand = "zealand",
    aalborg = "aalborg",
    nordjylland = "nordjylland",
    sonderjylland = "sonderjylland",
    himmerland = "himmerland",
    linkoping = "linkoping",
    jonkoping = "jonkoping",
    odense = "odense",
    other = "other"
}

export enum GenreTourTag {
    history = "history",
    nature = "nature",
    art = "art",
    urban = "urban",
    family = "family",
    culture = "culture",
    education = "education",
    cuisine = "cuisine",
    local = "local",
}

export enum OtherTourTag {
    original = "original",
    food_drinks = "food_drinks",
    news = "news",
    free = "free",
    near = "near"
}

export type TourTag = GeoTourTag | GenreTourTag | OtherTourTag;
